import React from 'react';
import { useQuery } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { DealActivityLinkType } from '@trnsact/trnsact-shared-types';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { Box, Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useModal } from 'hooks/useModal';
import { ModalsKeys } from 'global';

import { dealActivityApi } from '../api';
import { DealActivityListQuery } from '../api/types';
import { DealActivityList } from './DealActivityList';
import { DEFAULT_ACTIVITY_CARD_ITEMS } from '../constants';

interface Props {
  parentId: string;
  parentType: DealActivityLinkType;
}

export const DealActivityCard = ({ parentId, parentType }: Props) => {
  const { push } = useHistory();
  const { handleOpen: openActivityDialog } = useModal(ModalsKeys.ActivityDialog);

  const { data, loading } = useQuery<DealActivityListQuery>(dealActivityApi.dealActivities, {
    variables: {
      input: { parentId, limit: DEFAULT_ACTIVITY_CARD_ITEMS, parentType },
    },
  });

  const list = data?.dealActivity?.result?.list ?? [];

  return (
    <CardContainer
      title="Recent Activity"
      actionBtn={
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            startIcon={<Add />}
            onClick={() => openActivityDialog({ parentId, parentType, initialTab: 'NOTE' })}
          >
            Create Note
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            startIcon={<Add />}
            onClick={() => openActivityDialog({ parentId, parentType, initialTab: 'CALL' })}
          >
            Create Activity
          </Button>
          <Button
            size="small"
            onClick={() => {
              push({ pathname: `/dealActivity/${parentId}`, search: `?parentType=${parentType}` });
            }}
          >
            View All
          </Button>
        </Box>
      }
    >
      <DealActivityList parentId={parentId} list={list} loading={loading} parentType={parentType} />
    </CardContainer>
  );
};
